// extracted by css-extract-rspack-plugin
export default {"mappingsTable":"neRfv","header":"_inrl"};